import { useMutation } from '@apollo/client'
import graphql from '@src/graphql/mutation/createRoninMarketPlaceOrder'
import { useCallback, useState } from 'react'

const useCreateRoninMarketPlaceOrder = (): Hook => {
  const [createOrder, { loading }] = useMutation(graphql)

  const [data, setData] = useState<boolean | null>(null)

  const mutate = useCallback(
    async (request: Request): Promise<boolean> => {
      const response = await createOrder({
        variables: {
          input: request
        }
      })

      const result = response.data?.createRoninMarketPlaceOrder

      setData(result)

      return result
    },
    [createOrder]
  )

  return {
    mutate,
    data,
    loading
  }
}

type Request = {
  maker: string
  asset: {
    erc: number
    addr: string
    id: string
    quantity: string
  }
  expiredAt: string
  paymentToken: string
  startedAt: string
  basePrice: string
  endedAt: string
  endedPrice: string
  expectedState: string
  nonce: number
  marketFeePercentage: number
  signature: string
}

type Hook = {
  mutate: (request: Request) => Promise<boolean>
  data: boolean | null
  loading: boolean
}

export default useCreateRoninMarketPlaceOrder
